import {SchoolService} from '../services';
import {bindLoading} from './index';

export default {
    namespaced: true,
    state: {
        schoolInfo: undefined,
    },

    mutations: {
        saveSchoolInfo(current, schoolInfo) {
            current.schoolInfo = {...schoolInfo};
        }
    },

    actions: {
        async getSchoolInfoAction({commit}) {
            await bindLoading(commit,
                async () => commit('saveSchoolInfo', await SchoolService.getSchoolInfo()), 'school');
        }
    }
}